/**
 * Save one traveler's wheelchair assistance answers through the server
 * (PUT /api/passengers/:id/wheelchair-assistance, server/wheelchair-assistance.js).
 * Browsers can't write the column directly (migration 163), so this is the
 * only way a customer's change lands, and the server emails support@ about it.
 */
export async function saveWheelchairAnswers(passengerId, answers) {
  const { supabase } = await import('@/lib/supabase');
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Please sign in again to save.');
  const res = await fetch(`/api/passengers/${encodeURIComponent(passengerId)}/wheelchair-assistance`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session.access_token}` },
    body: JSON.stringify({ answers }),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body?.error || 'Could not save the answers.');
  return body;
}
